import React, { useState} from "react";
import cogoToast from "cogo-toast";
import { Modal,Button } from "semantic-ui-react";
import {ShipmentUndoBtnDisabled} from '../../utils/constant'
import {buttons,labels} from './ShipmentComponentConstants/modalUndoAllotedVendorConst'
import {REMARKS_REQUIRED} from '../../utils/toastMsgConstant'

const ModalUndoAllotedVendor = (props) => {
    const [modalOpen,setModalOpen] = useState(false)
    const [remarks, setRemarks] = useState('')

    const handleOpen = () => {
        setModalOpen(true)
    }
    const handleClose = () => {
        setModalOpen(false)
    }

    const handleOnChange = (value) =>{
        setRemarks(value)
    }

    const handleSubmit = () =>{
        if(!remarks || remarks.trim()===""){
            cogoToast.error(REMARKS_REQUIRED)
        }else{
            props.orderDetails.remarks = remarks.trim()
            props.undoAllotToVendor( 
                props.orderDetails.vendor_order_id,
                props.orderDetails.vendor_id,
                props.orderDetails
                )
        }
    }


    return (
        <Modal
            open={modalOpen}
            onClose={handleClose}
            size="small"
            style={{
                /* padding: '50px 0 50px 0' */
            }}
            trigger = {
                <Button
                type="button"
                disabled={
                  ShipmentUndoBtnDisabled
                    ? true
                    : false
                }
                onClick={handleOpen}
                size="mini"
                basic
                color="primary"
                // className="w3-blue w3-round w3-hover-blue"
              >
                {buttons.undo || "Undo"}
              </Button>
            }
        >
            <Modal.Header className="p-bold-100">
                <div className="d-flex justify-content-between">
                    <label className="font-weight-normal">{labels.undo_alloted_vendor||"Undo Alloted Vendor"}</label>
                    <div className="form-inline">
                        <i
                            onClick={handleClose}
                            className="fas fa-times"></i>
                    </div>
                </div>
            </Modal.Header>
            <Modal.Content scrolling>
                <label className="required-form-element">{labels.remarks||"Remarks"}</label><br /><br />
                <textarea rows="4" cols="50" id="rejection_reason" onChange={(e) =>handleOnChange(e.target.value)} />
                <div className="display-flex-center-justify-center" style={{
                    padding: '10px 0 10px 0'
                }}>
                    <button
                        className="submit-generate-order w3-button w3-blue w3-hover-blue w3-round w3-small"
                        onClick={handleSubmit}
                    >
                        <span>{buttons.submit||"Submit"}</span>
                    </button>
                </div>
            </Modal.Content>
            {/* </Formiker> */}
        </Modal>
    )
};

export default ModalUndoAllotedVendor